// Credentials and authorizations for Michigan Aviation.
// Holds only facts that siteConfig does not already carry.

export const credentials = {
  repairStation: {
    certificate: 'KL2R956K',
    type: 'FAA Part 145 repair station',
    ratings: [
      { category: 'Airframe', classes: ['Class 1', 'Class 3', 'Limited'] },
      { category: 'Powerplant', classes: ['Class 1', 'Limited'] },
      { category: 'Radio', classes: ['Class 1', 'Class 2', 'Class 3'] },
      { category: 'Instrument', classes: ['Limited'] },
      { category: 'Accessory', classes: ['Limited'] },
    ],
  },
  authorizations: [
    'Authorized Williams International dealer: FJ44-1, -2, -3 and -4 engines, with Williams TAP and TAP Blue support',
    'Authorized Garmin service center',
  ],
  programs: [
    'OEM hourly maintenance programs, including Williams engine programs and Cessna Citation programs',
  ],
  engineFamilies: [
    'Williams FJ44',
    'Pratt & Whitney Canada PT6 and PW300',
    'Honeywell TFE731 and HTF7000',
    'Rolls-Royce AE 3007',
    'Lycoming',
    'Continental',
  ],
} as const
